<div class="top-consumers-config" *ngIf="topConsumersForm" [formGroup]="topConsumersForm">
  <div class="field">
    <label class="field__label">Defined By</label>
    <p-selectButton
      [options]="rankingMetricOptions"
      formControlName="RankingMetric"
      optionLabel="label"
      optionValue="value"
    ></p-selectButton>
  </div>

  <div class="field">
    <label class="field__label">Audience Size</label>
    <p-selectButton
      [options]="audienceSizeOptions"
      formControlName="AudienceSizeType"
      optionLabel="label"
      optionValue="value"
    ></p-selectButton>
    <div class="custom-count-input" *ngIf="isCustomAudienceSize">
      <label class="field__label" for="customCount">Number of Customers</label>
      <p-inputNumber
        inputId="customCount"
        formControlName="CustomCount"
        [min]="1"
        [showButtons]="false"
        [useGrouping]="false"
      ></p-inputNumber>
      <small
        class="p-error"
        *ngIf="topConsumersForm.controls.CustomCount.dirty && topConsumersForm.controls.CustomCount.invalid"
      >
        Customer count is required
      </small>
    </div>
  </div>

  <div class="field">
    <label class="field__label">Date Range</label>
    <p-selectButton
      [options]="dateRangeOptions"
      formControlName="DateRangePreset"
      optionLabel="label"
      optionValue="value"
    ></p-selectButton>
    <div class="date-range-picker">
      <p-calendar
        formControlName="DateRangeStart"
        [showIcon]="true"
        dateFormat="mm/dd/yy"
        placeholder="Start date"
        [maxDate]="topConsumersForm.controls.DateRangeEnd.value || today"
        [readonlyInput]="false"
      ></p-calendar>
      <span class="date-separator">to</span>
      <p-calendar
        formControlName="DateRangeEnd"
        [showIcon]="true"
        dateFormat="mm/dd/yy"
        placeholder="End date"
        [minDate]="topConsumersForm.controls.DateRangeStart.value"
        [maxDate]="today"
        [readonlyInput]="false"
      ></p-calendar>
    </div>
  </div>
</div>
